import TravelHomeMain from "./TravelHomeMain";

export default TravelHomeMain;